import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

export function useDestinationThemeModuleAnalytics(placementData, themeStations = []) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const { contentBlockId = "" } = placementData ?? {};

  useEffect(() => {
    if ((pathname === "/" || pathname.includes("/landing/home-page/")) && contentBlockId) {
      setMktgPageData(
        {
          moduledetaildestinationthemes: getModuleDetails(),
        },
        "landingHomePage"
      );
    }
  }, [pathname, placementData]);

  function getModuleDetails() {
    return themeStations?.map((station) => `${contentBlockId};;${station};`).join();
  }
}
